import React, { useState } from "react";
import AdminSearchTable from "../../Components/Admin/AdminSearchTable";
import FilterIcon from "../../SVG/Filter";
import { useAuth } from "../../src/Context/AuthContext";
import { useNavigate } from "react-router-dom";
import EmptyHeader from "../../Components/Shared/EmptyHeader";

const RetentionLimitPage = () => {
    const [ssn, setSsn] = useState("");
    const [retentionList, setRetentionList] = useState([]);
    const [loading, setLoading] = useState(false);

    const { logout } = useAuth();
    const navigate = useNavigate();


    //ENV Variables
    const companyName = import.meta.env.VITE_COMPANY_NAME;
    const apiURL = import.meta.env.VITE_API;

    //Set Site Title
    document.title = `${companyName} - Retention Limit`;

    const handleSearch = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);

            const query = new URLSearchParams({
                ssn: ssn || ""
            });

            const res = await fetch(
                `${apiURL}/underwriting/GetRetentionLimit?${query.toString()}`,
                {
                    method: "GET",
                    credentials: "include"
                }
            );

            if (res.status === 401) {
                logout();
                navigate("/login");
                throw new Error("unauthorized");
            }

            if (res.status === 403) {
                navigate("/home");
                throw new Error("forbidden");
            }

            if (!res.ok) {
                throw new Error("Failed to fetch retention list.");
            }

            const data = await res.json();
            setRetentionList(data || []);
        } catch (error) {
            console.error("Error fetching policies:", error);
            alert("Error fetching policies.");
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        { label: "Policy Number", accessor: "polNo" },
        { label: "App Date", accessor: "appDate" },
        { label: "Date Issued", accessor: "issDate" },
        { label: "Premium", accessor: "premiumAmount" },
        { label: "Term Length", accessor: "termLength" },
        { label: "Status", accessor: "statusDesc" },
    ];

    return (
        <div className="admin-materials-page">
            <EmptyHeader></EmptyHeader>
            <form className="filter-box" onSubmit={handleSearch}>
                <FilterIcon />

                <div className="filter-item">
                    <label className="filterLabel">SSN</label>
                    <input
                        type="text"
                        className="filterInput"
                        placeholder="Enter SSN"
                        value={ssn}
                        onChange={(e) => setSsn(e.target.value)}
                    />
                </div>

                <div className="filter-button-box">
                    <button
                        type="submit"
                        className="filterButton"
                        disabled={loading}
                    >
                        {loading ? "Searching..." : "Search"}
                    </button>
                </div>
            </form>

            {loading ? (
                <div>Loading...</div>
            ) : (
                <AdminSearchTable columns={columns} data={retentionList} />
            )}
        </div>
    );
};

export default RetentionLimitPage;